import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

export const LangContext = createContext({ lang: 'de', setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    // 1. Respect explicit user choice stored in localStorage
    const stored = localStorage.getItem('appLang');
    if (stored) return stored;
    // 2. First visit — auto-detect from browser language
    const browserLang = navigator.language || navigator.userLanguage || '';
    const detected = browserLang.toLowerCase().startsWith('de') ? 'de' : 'en';
    localStorage.setItem('appLang', detected);
    return detected;
  });

  // Load from DB when a token is present (after login).
  // Skip for demo users — their language was set from the landing page and
  // the demo team's DB language should not override that choice.
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const stored = localStorage.getItem('userInfo');
      if (stored && JSON.parse(stored)?.isDemo) return;
    } catch {}
    axios.get('/api/settings', { headers: { Authorization: `Bearer ${token}` } })
      .then(res => {
        const dbLang = res.data.language;
        if (dbLang && (dbLang === 'de' || dbLang === 'en')) {
          setLangState(dbLang);
          localStorage.setItem('appLang', dbLang);
        }
      })
      .catch(() => {});
  }, []); // runs once on mount — token is in localStorage by the time App renders

  const setLang = async (newLang) => {
    setLangState(newLang);
    localStorage.setItem('appLang', newLang);
    const token = localStorage.getItem('token');
    if (token) {
      try {
        await axios.put('/api/settings/language', { language: newLang }, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch (_) {}
    }
  };

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
